// hooks/useHeicConverter.js
import { useState, useCallback } from 'react';
import heic2any from 'heic2any';

export const useHeicConverter = () => {
    const [converting, setConverting] = useState(false);

    const convertHeicToJpeg = useCallback(async (file) => {
        if (!file || (!file.type.includes('heic') && !file.name.toLowerCase().endsWith('.heic'))) {
            return file;
        }

        setConverting(true);
        try {
            // Конвертируем HEIC в JPEG используя heic2any
            const convertedBlob = await heic2any({
                blob: file,
                toType: 'image/jpeg',
                quality: 0.8
            });

            const convertedFile = new File(
                [convertedBlob],
                file.name.replace(/\.heic$/i, '.jpg'),
                { type: 'image/jpeg' }
            );

            return convertedFile;
        } catch (error) {
            console.error('HEIC conversion error:', error);
            throw new Error('Не удалось конвертировать HEIC файл');
        } finally {
            setConverting(false);
        }
    }, []);

    return { convertHeicToJpeg, converting };
};